@if (paperLayout()) {
  @if (stockFileDTO().identified) {
    <div class="mt-shell">
      <header class="mt-head">
        <div class="mt-head-text">
          <h2 class="mt-title">Match and Tune Files</h2>
          <p class="mt-sub">Vehicle matched · select tunings to apply.</p>
        </div>
        <div class="mt-head-actions">
          <span class="mt-badge mt-badge--ok">
            <span class="mt-badge-dot"></span>
            MATCHED
          </span>
        </div>
      </header>

      <div class="mt-hero">
        <div class="mt-hero-visual">
          <img
            *ngIf="carImageService.image && !imageIsLoading()"
            [src]="carImageService.image"
            alt=""
          />
          <div *ngIf="imageIsLoading()" class="mt-hero-skeleton"></div>
          <div *ngIf="!carImageService.image && !imageIsLoading()" class="mt-hero-placeholder" aria-hidden="true">
            <svg width="200" height="130" viewBox="0 0 200 130" fill="none" xmlns="http://www.w3.org/2000/svg">
              <ellipse cx="100" cy="115" rx="84" ry="6" fill="#000000" opacity="0.08" />
              <path
                d="M22 92 Q22 60 50 50 L82 36 Q98 28 120 28 L160 28 Q178 28 190 40 L208 60 Q214 70 214 82 L214 92 Z"
                fill="#D5D7DC"
                stroke="#8A8DC1"
                stroke-width="1.4"
                stroke-linejoin="round"
                transform="translate(-8,0)"
              />
              <path d="M68 50 L88 36 Q94 32 104 32 L130 32 L140 50 Z" fill="#B5C8DC" opacity="0.7" />
              <path d="M142 50 L152 36 L160 36 Q168 36 174 42 L182 50 Z" fill="#B5C8DC" opacity="0.7" />
              <line x1="140" y1="32" x2="140" y2="50" stroke="#8A8DC1" stroke-width="1.2" />
              <circle cx="56" cy="95" r="16" fill="#1A1B26" />
              <circle cx="56" cy="95" r="11" fill="#3D3F50" />
              <circle cx="56" cy="95" r="5" fill="#8A8DC1" />
              <circle cx="166" cy="95" r="16" fill="#1A1B26" />
              <circle cx="166" cy="95" r="11" fill="#3D3F50" />
              <circle cx="166" cy="95" r="5" fill="#8A8DC1" />
              <rect x="186" y="58" width="14" height="6" rx="2" fill="#FFC76A" />
            </svg>
          </div>
        </div>

        <div class="mt-hero-copy">
          <div class="mt-vhead">
            <div class="mt-kicker-row">
              <span class="mt-kicker">VEHICLE BUILD</span>
              <button
                type="button"
                class="mt-kicker-eye"
                (click)="openPureOriginalDetails(stockFileDTO().pureOriginalId)"
                title="View original"
                aria-label="View original"
              >
                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12C23 12 19 20 12 20C5 20 1 12 1 12Z" />
                  <circle cx="12" cy="12" r="3" />
                </svg>
              </button>
            </div>
            <p class="mt-vtitle">{{ vehicleHeadline() }}</p>
          </div>
          <div class="mt-chips">
            <span class="mt-chip" *ngIf="stockFileDTO().engineType">{{ stockFileDTO().engineType }}</span>
            <span class="mt-chip" *ngIf="stockFileDTO().engineDisplacement != null">
              {{ (+stockFileDTO().engineDisplacement).toFixed(1) }} L
            </span>
            <span class="mt-chip" *ngIf="stockFileDTO().engineName">{{ stockFileDTO().engineName }}</span>
            <span class="mt-chip" *ngIf="stockFileDTO().engineTransmission">{{ stockFileDTO().engineTransmission }}</span>
            <span class="mt-chip mt-chip--accent" *ngIf="stockFileDTO().ecuProducer || stockFileDTO().ecuBuild">
              <ng-container *ngIf="stockFileDTO().ecuProducer">{{ stockFileDTO().ecuProducer }}</ng-container>
              <ng-container *ngIf="stockFileDTO().ecuProducer && stockFileDTO().ecuBuild"> / </ng-container>
              <ng-container *ngIf="stockFileDTO().ecuBuild">{{ stockFileDTO().ecuBuild }}</ng-container>
            </span>
          </div>
          <div class="mt-stat-row">
            <div class="mt-stat">
              <span class="mt-stat-k">YEAR</span>
              <span class="mt-stat-v">{{ stockFileDTO().vehicleModelYear }}</span>
            </div>
            <div class="mt-stat mt-stat--grow">
              <span class="mt-stat-k">ECU VERSION</span>
              <span class="mt-stat-v mt-stat-mono">{{ stockFileDTO().ecuSoftwareVersion }}</span>
            </div>
            <div class="mt-stat">
              <span class="mt-stat-k">ECU USE</span>
              <span class="mt-stat-v">{{ stockFileDTO().ecuUse }}</span>
            </div>
          </div>
        </div>
      </div>

      <app-user-input-selection
        [paperLayout]="true"
        [stockFileDTO]="stockFileDTO()"
        [selectedOptions]="tuningService.selectedOptions"
        [ecuBuildNameControl]="ecuBuildNameControl"
        [unidentified]="false"
        [scrollOtherSection]="false"
        (activeOption)="setOptionToActive($event)"
        (stockFileBlobName)="requestFileTune($event)"
      ></app-user-input-selection>
    </div>
  } @else {
    <div class="mt-shell mt-shell--unknown">
      <header class="mt-head">
        <div class="mt-head-text">
          <h2 class="mt-title">Match and Tune Files</h2>
          <p class="mt-sub">Unknown ECU · please specify the build for a manual tune.</p>
        </div>
        <div class="mt-head-actions">
          <span class="mt-badge mt-badge--warn">
            <span class="mt-badge-dot"></span>
            UNKNOWN
          </span>
          <button
            type="button"
            class="mt-icon-btn mt-icon-btn--warn"
            (click)="restartUpload()"
            title="Try another file"
            aria-label="Try another file"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M3 12a9 9 0 1 0 3-6.7" />
              <path d="M3 4v5h5" />
            </svg>
          </button>
        </div>
      </header>

      <div class="mt-hero mt-hero--unknown">
        <div class="mt-unknown-visual">
          <div class="mt-unknown-ico-wrap">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#E8A838" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
              <line x1="12" y1="22" x2="12" y2="12" />
              <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
            </svg>
          </div>
          <div class="mt-unknown-labels">
            <span class="mt-unknown-title">Vehicle unknown</span>
            <span class="mt-unknown-sub">No matching record</span>
          </div>
        </div>

        <div class="mt-unknown-side">
          <div class="mt-alert">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#FF6B8B" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
            <div class="mt-alert-text">
              <span class="mt-alert-title">File is not in our database</span>
              <span class="mt-alert-sub">Specify the ECU build manually below to request a tune.</span>
            </div>
          </div>

          <div class="mt-ecu-block">
            <span class="mt-ecu-label">ECU BUILD *</span>
            <div class="mt-ecu-input-row">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#8A8DC1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <rect x="2" y="6" width="20" height="12" rx="2" />
                <line x1="6" y1="10" x2="6" y2="14" />
                <line x1="10" y1="10" x2="10" y2="14" />
                <line x1="14" y1="10" x2="14" y2="14" />
                <line x1="18" y1="10" x2="18" y2="14" />
              </svg>
              <input
                type="text"
                class="mt-ecu-input"
                matInput
                [formControl]="ecuBuildNameControl"
                [matAutocomplete]="autoUnknown"
                placeholder="e.g. EDC17C46_BMW_320d_v2"
                [attr.aria-label]="'ECU build'"
              />
              <span class="mt-ecu-required">REQUIRED</span>
            </div>
            <mat-autocomplete #autoUnknown="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{ option.correctEcuBuildNames }}
              </mat-option>
            </mat-autocomplete>
            <p class="mt-ecu-error" *ngIf="ecuBuildNameControl.hasError('required') && ecuBuildNameControl.touched">Invalid ECU name</p>
          </div>
        </div>
      </div>

      <app-user-input-selection
        [paperLayout]="true"
        [stockFileDTO]="stockFileDTO()"
        [selectedOptions]="tuningService.selectedOptions"
        [ecuBuildNameControl]="ecuBuildNameControl"
        [unidentified]="true"
        [scrollOtherSection]="true"
        (activeOption)="setOptionToActive($event)"
        (stockFileBlobName)="requestFileTune($event)"
      ></app-user-input-selection>
    </div>
  }
} @else {
  <div class="selected-options-container">
    @if (stockFileDTO().identified) {
      <div class="car-image-container">
        <app-user-input-car-details
          [carImage]="carImageService.image"
          [imageIsLoading]="imageIsLoading()"
          [stockFileDTO]="stockFileDTO()"
        ></app-user-input-car-details>
      </div>
    } @else {
      <div>
        <div class="custom-file-title">
          <span>File is not in our database.</span>
          <span class="red">Please specify ecu build for manual tune.</span>
        </div>
        <form class="example-form">
          <mat-form-field class="example-full-width">
            <mat-label>Ecu Build</mat-label>
            <input type="text" matInput [formControl]="ecuBuildNameControl" [matAutocomplete]="autoLegacy" />
            <mat-autocomplete #autoLegacy="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                {{ option.correctEcuBuildNames }}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="ecuBuildNameControl.hasError('required') && ecuBuildNameControl.touched">Invalid ECU Name</mat-error>
          </mat-form-field>
        </form>
      </div>
    }

    <app-user-input-selection
      [paperLayout]="false"
      [stockFileDTO]="stockFileDTO()"
      [ecuBuildNameControl]="ecuBuildNameControl"
      [selectedOptions]="tuningService.selectedOptions"
      (activeOption)="setOptionToActive($event)"
      (stockFileBlobName)="requestFileTune($event)"
    ></app-user-input-selection>
  </div>
}
